"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _resolvers = require("@hookform/resolvers");

var parseErrors = function parseErrors(errors) {
  var parsedErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return Object.keys(errors).reduce(function (acc, key) {
    var errorPath = path ? "".concat(path, ".").concat(key) : key;
    var error = errors[key];

    if (typeof error === 'string') {
      acc[errorPath] = {
        message: error
      };
    } else {
      parseErrors(error, acc, errorPath);
    }

    return acc;
  }, parsedErrors);
};

var schemataResolver = function schemataResolver(schema) {
  var schemaOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (object, context, options) {
    return new Promise(function (resolve, reject) {
      var set = schemaOptions.set,
          tag = schemaOptions.tag,
          persist = schemaOptions.persist,
          ignoreTagForSubSchema = schemaOptions.ignoreTagForSubSchema;
      var cleanObject = schema.cast(schema.stripUnknownProperties(schema.makeDefault(object), persist || tag, ignoreTagForSubSchema));
      schema.validate(cleanObject, set, tag, function (error, validationErrors) {
        if (error) return reject(error);

        if (validationErrors && Object.keys(validationErrors).length) {
          return resolve({
            values: cleanObject,
            errors: (0, _resolvers.toNestError)(parseErrors(validationErrors), options)
          });
        }

        options.shouldUseNativeValidation && (0, _resolvers.validateFieldsNatively)({}, options);
        resolve({
          values: cleanObject,
          errors: {}
        });
      });
    });
  };
};

var _default = schemataResolver;
exports["default"] = _default;